/* Already Loved Club — slide-in cart drawer.
   Intercepts add-to-cart and bag links, talks to Shopify's /cart/*.js endpoints,
   and sends the shopper straight to /checkout. Degrades to the normal /cart page
   if anything here throws or JS is off. */
(function () {
  'use strict';

  var root = document.querySelector('[data-cd]');
  var cfgEl = document.querySelector('[data-cd-config]');
  if (!root || !cfgEl) return;

  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { cfg = { freeShipCents: 0, upsell: [] }; }

  var scrim   = document.querySelector('[data-cd-scrim]');
  var itemsEl = root.querySelector('[data-cd-items]');
  var emptyEl = root.querySelector('[data-cd-empty]');
  var footEl  = root.querySelector('[data-cd-foot]');
  var totalEl = root.querySelector('[data-cd-total]');
  var countEl = root.querySelector('[data-cd-count]');
  var shipEl  = root.querySelector('[data-cd-ship]');
  var shipTxt = root.querySelector('[data-cd-shiptxt]');
  var barFill = root.querySelector('[data-cd-barfill]');
  var upEl    = root.querySelector('[data-cd-upsell]');
  var upRow   = root.querySelector('[data-cd-uprow]');

  var busy = false;

  function money(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function open(v) {
    root.classList.toggle('on', v);
    root.setAttribute('aria-hidden', v ? 'false' : 'true');
    if (scrim) { scrim.hidden = !v; scrim.classList.toggle('on', v); }
    document.body.style.overflow = v ? 'hidden' : '';
  }

  function getCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }

  function render(cart) {
    var n = cart.item_count;
    countEl.textContent = '(' + n + ')';

    // Cart-capture hook: every render (add/change/remove/load-prime) reports the
    // cart for abandoned-cart recovery and sizes up the "save your rack" field.
    if (window.__alcCartCapture) { try { window.__alcCartCapture.onCart(cart); } catch (e) {} }

    // header bag counters elsewhere on the page
    Array.prototype.forEach.call(document.querySelectorAll('[data-alc-bagcount]'), function (el) {
      el.textContent = n;
      // the mobile badge is hidden at zero; the desktop "BAG (n)" text is not
      if (el.classList.contains('bagct')) el.hidden = (n === 0);
    });

    if (!n) {
      itemsEl.innerHTML = '';
      emptyEl.hidden = false;
      footEl.hidden = true;
      shipEl.hidden = true;
      upEl.hidden = true;
      return;
    }
    emptyEl.hidden = true;
    footEl.hidden = false;

    itemsEl.innerHTML = cart.items.map(function (it, i) {
      var line = i + 1;
      var variant = (it.variant_title && it.variant_title.indexOf('Default') === -1)
        ? '<div class="cd-var">' + esc(it.variant_title) + '</div>' : '';
      var img = it.image
        ? '<img class="cd-img" src="' + esc(sized(it.image, 200)) + '" alt="" loading="lazy">'
        : '<div class="cd-img"></div>';
      return '' +
        '<div class="cd-row" data-line="' + line + '">' +
          '<a href="' + esc(it.url) + '">' + img + '</a>' +
          '<div class="cd-info">' +
            '<a class="cd-name" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
            variant +
            '<div class="cd-qty">' +
              '<div class="cd-qbox">' +
                '<button type="button" data-cd-dec aria-label="Decrease">&minus;</button>' +
                '<span>' + it.quantity + '</span>' +
                '<button type="button" data-cd-inc aria-label="Increase">+</button>' +
              '</div>' +
              '<button type="button" class="cd-rm" data-cd-rm>REMOVE</button>' +
            '</div>' +
          '</div>' +
          '<div class="cd-price">' + money(it.final_line_price) + '</div>' +
        '</div>';
    }).join('');

    totalEl.textContent = money(cart.total_price);
    renderShip(cart.total_price);
    renderUpsell(cart);
  }

  function renderShip(total) {
    var t = cfg.freeShipCents;
    if (!t) { shipEl.hidden = true; return; }
    shipEl.hidden = false;
    var pct = Math.max(0, Math.min(100, Math.round((total / t) * 100)));
    barFill.style.width = pct + '%';
    if (total >= t) {
      shipEl.classList.add('is-done');
      shipTxt.textContent = 'FREE U.S. SHIPPING UNLOCKED';
    } else {
      shipEl.classList.remove('is-done');
      // Deliberately NOT a dollar countdown. The cheapest piece in the shop is
      // $98, so "$24 AWAY" reads as a small top-up the shopper cannot actually
      // make — the only move is a second piece, which always clears the bar.
      shipTxt.textContent = 'ADD ONE MORE PIECE FOR FREE U.S. SHIPPING';
    }
  }

  function renderUpsell(cart) {
    var inCart = {};
    cart.items.forEach(function (i) { inCart[i.id] = true; });
    var picks = (cfg.upsell || []).filter(function (p) { return !inCart[p.id]; }).slice(0, 6);
    if (!picks.length) { upEl.hidden = true; return; }
    upEl.hidden = false;
    upRow.innerHTML = picks.map(function (p) {
      return '' +
        '<div class="cd-up">' +
          '<a href="' + esc(p.url) + '"><img src="' + esc(p.img) + '" alt="" loading="lazy"></a>' +
          '<div class="cd-upname">' + esc(p.title) + '</div>' +
          '<div class="cd-upfoot">' +
            '<span>' + money(p.price) + '</span>' +
            '<button type="button" class="cd-upadd" data-cd-upadd="' + p.id + '">ADD</button>' +
          '</div>' +
        '</div>';
    }).join('');
  }

  function sized(url, w) {
    // Shopify CDN urls accept a width param
    return url.indexOf('?') > -1 ? url + '&width=' + w : url + '?width=' + w;
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function refresh(openAfter) {
    return getCart().then(function (cart) {
      render(cart);
      if (openAfter) open(true);
    });
  }

  function change(line, qty) {
    if (busy) return Promise.resolve();
    busy = true;
    root.classList.add('is-busy');
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ line: line, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function () { window.location.href = '/cart'; })
      .finally(function () { busy = false; root.classList.remove('is-busy'); });
  }

  function addId(id, qty) {
    if (busy) return Promise.resolve();
    busy = true;
    root.classList.add('is-busy');
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return refresh(true);
      })
      .catch(function () { window.location.href = '/cart'; })
      .finally(function () { busy = false; root.classList.remove('is-busy'); });
  }

  /* ---- wiring ---- */

  // Add to cart from any product form
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
    e.preventDefault();
    var fd = new FormData(form);
    var btn = form.querySelector('[type="submit"]');
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'ADDING…'; }
    fetch('/cart/add.js', { method: 'POST', body: fd, credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return refresh(true);
      })
      .catch(function () { form.submit(); })
      .finally(function () { if (btn) { btn.disabled = false; btn.textContent = label; } });
  });

  // Bag links open the drawer instead of navigating
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href$="/cart"], a[href="/cart"], [data-cd-open]');
    if (a && !a.hasAttribute('data-cd-nodrawer')) {
      e.preventDefault();
      refresh(true);
      return;
    }

    if (e.target.closest('[data-cd-close]')) { open(false); return; }
    if (scrim && e.target === scrim) { open(false); return; }

    var row = e.target.closest('.cd-row');
    if (row) {
      var line = parseInt(row.getAttribute('data-line'), 10);
      var qtyEl = row.querySelector('.cd-qbox span');
      var q = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
      if (e.target.closest('[data-cd-inc]')) { change(line, q + 1); return; }
      if (e.target.closest('[data-cd-dec]')) { change(line, Math.max(0, q - 1)); return; }
      if (e.target.closest('[data-cd-rm]'))  { change(line, 0); return; }
    }

    var up = e.target.closest('[data-cd-upadd]');
    if (up) { addId(parseInt(up.getAttribute('data-cd-upadd'), 10), 1); return; }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('on')) open(false);
  });

  // Prime counts on load (cheap, and keeps the bag badge honest after a back-button)
  getCart().then(render).catch(function () {});
})();


